//App.tsx
import React, { useEffect, useState } from "react";
import { NavigationContainer } from "@react-navigation/native";
import { createStackNavigator } from "@react-navigation/stack";
import { View, StyleSheet, Platform } from "react-native";
import LoginScreen from "./src/screens/LoginScreen";
import HomeScreen from "./src/screens/HomeScreen";
import { injectMapboxStyles } from "./src/mapbox-styles";
// import RestaurantRegistrationPage from "./src/screens/restaurant/RestaurantRegistrationPage";
import HelpScreen from "./src/components/shared/screens/HelpScreen";
import NavigationMenu from "./src/components/layout/NavigationMenu";
// import { initializeOrderService, Order } from "./src/services/order.service";
// import { NewOrderPopup } from "./src/components/orders/NewOrderPopup";
// import ComingSoonScreenUI from "./src/screens/ComingSoonScreenUI";
// import OTPVerificationScreen from "./src/screens/OTPVerificationScreen";
import { RootStackParamList } from "./src/types/navigation";
// import { restaurantService } from "./src/services/restaurant.service";
import { secureStoreService } from "./src/components/shared/services/secure-store.service";
import LoadingSpinner from "./src/components/shared/LoadingSpinner";
import OTPVerificationScreen from "./src/components/shared/screens/OTPVerificationScreen";
import MenuScreen from "./src/components/shared/screens/MenuScreen";
import { RestaurantMenu } from "./src/screens/RestaurantMenu";
import CartScreen from "./src/screens/CartScreen";
import OrderTrackingScreen from "./src/screens/OrderTrackingScreen";
import UserAddress from "./src/components/shared/screens/UserAddress";
import UserAccountScreen from "./src/components/shared/screens/UserAccountScreen";
import AddressSelectionScreen from "./src/screens/AddressSelectionScreen";
import DeliveryLocationScreen from "./src/screens/DeliveryLocationScreen";
import AddressDetailsScreen from "./src/screens/AddressDetailsScreen";
import {
  fetchRestaurantIdByName,
  linkingConfig,
} from "./src/pwa/linking.config";
import { config } from "./src/config";
import { checkSubdomain, SubdomainCheck } from "./src/pwa/helpers";
import { Environment } from "./src/config.types";
const Stack = createStackNavigator<RootStackParamList>();
const styles = StyleSheet.create({
  container: {
    flex: 1,
    overflow: "scroll", // Enable scrolling on web
  },
  scrollView: {
    flex: 1,
    minHeight: "100%",
  },
  content: {
    flexGrow: 1,
  },
});

export default function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isPhoneVerified, setIsPhoneVerified] = useState(false);
  const [initialRoute, setInitialRoute] =
    useState<keyof RootStackParamList>("Login");
  const [restId, setRestId] = useState<string>("");
  useEffect(() => {
    if (typeof document !== "undefined") {
      injectMapboxStyles();
    }
    checkAuthStatus();
  }, []);

//   useEffect(() => {
//     console.log("env: ", config.env, "os: ", Platform.OS)
//   // if (Platform.OS === 'web' && config.env == Environment.DEV) {
//   //   console.log("set meta for allowing http")
//   //   const meta = document.createElement('meta');
//   //   meta.httpEquiv = 'Content-Security-Policy';
//   //   meta.content = 'upgrade-insecure-requests';
//   //   document.head.appendChild(meta);
//   // }
// }, []);

  const checkAuthStatus = async (): Promise<void> => {
    try {
      const token = await secureStoreService.getAccessToken();
      console.log("token: ", token);
      const phVerStatus = await secureStoreService.getPhoneVerificationStatus();
      setIsAuthenticated(!!token);
      setIsPhoneVerified(phVerStatus === "true");

      let initial: keyof RootStackParamList = "Login";
      if (!!token && phVerStatus === "true") {
        initial = "HomeScreen";

        console.log(
          "window.location.hostname: ",
          window?.location?.hostname,
          Platform.OS
        );

        const { isSubdomain, subdomain }: SubdomainCheck = checkSubdomain();
        console.log("isSubdomain, subdomain: ", isSubdomain, subdomain);
        if (isSubdomain && subdomain) {
          const restaurantId = await fetchRestaurantIdByName(subdomain);
          console.log("restaurantId:", restaurantId);
          setRestId(restaurantId);
          initial = "RestaurantMenu";
        }
      }

      setInitialRoute(initial); // Add this state
      console.log("[Auth] Status:", {
        initial,
        hasToken: !!token,
        phVerStatus,
      });
    } catch (error) {
      console.error("[Auth] Error:", error);
      setIsAuthenticated(false);
      setIsPhoneVerified(false);
      setInitialRoute("Login");
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }

  console.log("Using linking config:", linkingConfig);

  return (
    <View style={styles.container}>
      <NavigationContainer
        linking={linkingConfig}
        onReady={() => {
          if (Platform.OS == "web") {
            console.log("Navigation container is ready");
            console.log("Current URL:", window?.location?.href);
            console.log("Hostname:", window?.location?.hostname);
            console.log("Pathname:", window?.location?.pathname);
          }
        }}
        onStateChange={(state) => console.log("Nav state changed:", state)}
        fallback={<LoadingSpinner />}
      >
        {/* <NewOrderPopup newOrders={newOrders} /> */}
        <Stack.Navigator
          initialRouteName={initialRoute}
          screenOptions={{
            headerShown: false,
            cardStyle: { backgroundColor: "white" },
          }}
        >
          <Stack.Screen
            name="OTPVerification"
            component={OTPVerificationScreen}
          />
          <Stack.Screen name="Navigation" component={NavigationMenu} />
          <Stack.Screen name="UserAddress" component={UserAddress} />
          {/* 
          
          <Stack.Screen name="ComingSoon" component={ComingSoonScreenUI} /> */}
          <Stack.Screen name="HomeScreen" component={HomeScreen} />
          <Stack.Screen
            name="Login"
            component={LoginScreen}
            initialParams={{
              showPhoneInput: isAuthenticated && !isPhoneVerified,
            }}
          />
          <Stack.Screen name="Help" component={HelpScreen} />
          <Stack.Screen
            name="UserAccountScreen"
            component={UserAccountScreen}
          />
          <Stack.Screen
            name="RestaurantMenu"
            component={RestaurantMenu}
            initialParams={{
              id: restId,
              updatedAt: "",
              onEditPress: () => {},
            }}
          />
          <Stack.Screen
            name="AddressDetailsScreen"
            component={AddressDetailsScreen}
          />
          <Stack.Screen
            name="AddressSelectionScreen"
            component={AddressSelectionScreen}
          />
          <Stack.Screen name="CartScreen" component={CartScreen} />
          <Stack.Screen
            name="DeliveryLocationScreen"
            component={DeliveryLocationScreen}
          />

          <Stack.Screen
            name="OrderTrackingScreen"
            component={OrderTrackingScreen}
          />
        </Stack.Navigator>
      </NavigationContainer>
    </View>
  );
}
